import styled from '@emotion/styled';
import { ReactComponent as EmailGeneralIcon } from '@ui-components/neo.tax/dist/icons/email-general.svg';

export const StyledEmailGeneralIcon = styled(EmailGeneralIcon)({
  height: '1.5rem',
  width: '1.5rem',
});
